import React from "react";
import USerTableRow from "./USerTableRow";

function UserTable({ apiData, user, handleSingleDelete, handleUserEdit }) {
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-6 py-3">
              SERIAL NO
            </th>
            <th scope="col" className="px-6 py-3">
              USER
            </th>
            <th scope="col" className="px-6 py-3">
              FULL NAME
            </th>
            <th scope="col" className="px-6 py-3">
              CREATED DATE
            </th>
            <th scope="col" className="px-6 py-3">
              STATUS
            </th>
            <th scope="col" className="px-6 py-3">
              ACTION
            </th>
          </tr>
        </thead>
        <tbody>
          {apiData?.map((item, idx) => (
            <USerTableRow
              key={idx}
              item={item}
              user={user}
              idx={idx}
              handleSingleDelete={handleSingleDelete}
              handleUserEdit={handleUserEdit}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UserTable;
